import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
const Container = styled.nav `
  ${scrollbars};

  --scrollbar-width: 4px;

  display: flex;
  color: var(--fgColor);
  flex-wrap: wrap;
  padding-bottom: 4px;

  &[data-theme='dark'] {
    --fgColor: ${brand.black};
  }

  &[data-theme='light'] {
    --fgColor: ${brand.white};
  }
`;
const Item = styled.div `
  &:not(:last-child)::after {
    content: '/';
    margin: 0 6px;
  }

  /* Hide all but the last 2 items on mobile */
  @media ${until(Device.MobileLarge)} {
    ${Container}[data-truncate='true'] &:not(:nth-last-child(-n + 2)) {
      ${srOnly}
    }
  }
`;
const Link = styled.a `
  color: currentColor;
  ${fonts.sofiaPro.regular};
  font-size: 17px;
  letter-spacing: 0.1em;
  line-height: 1em;
  text-decoration: none;
  text-transform: uppercase;
  text-underline-position: under;

  &:focus-visible {
    outline: auto;
  }

  &:hover {
    text-decoration: underline;
  }

  &[aria-current='page'] {
    text-decoration: none;

    &:focus,
    &:hover {
      text-decoration: none;
    }
  }
`;
const BreadcrumbStyles = {
    Container,
    Item,
    Link,
};
export default BreadcrumbStyles;
